import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type WorkOrder } from 'types/Squares/WorkOrderManagement/work.order.management.types';

interface WorkOrdersState {
  all: WorkOrder[];
  loading: boolean;
  error: string | null;
}

const initialState: WorkOrdersState = {
  all: [],
  loading: false,
  error: null,
};

const workOrdersSlice = createSlice({
  name: 'workOrders',
  initialState,
  reducers: {
    setWorkOrders(state, action: PayloadAction<WorkOrder[]>) {
      state.all = action.payload;
    },
    clearWorkOrders(state) {
      state.all = [];
      state.error = null;
      state.loading = false;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const { setWorkOrders, clearWorkOrders, setLoading, setError } =
  workOrdersSlice.actions;
export default workOrdersSlice.reducer;
